import React from "react";
import { Grid, Typography, Box, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TeacherCheckInCard } from "../../components/teacher-attendance/TeacherCheckInCard";
import { TeacherAttendanceCalendar } from "../../components/teacher-attendance/TeacherAttendanceCalendar";

const TeacherAttendancePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 1.5, maxWidth: 1500, mx: "auto", mt: 1 }}>
      <Box sx={{ mb: 1.5 }}>
        <Typography variant="h6" fontWeight={700} sx={{ fontSize: "1.25rem" }}>
          {t("my_attendance_dashboard", "My Attendance Dashboard")}
        </Typography>
        {/* <Typography variant="body2" color="text.secondary">
          {t("attendance_subtitle", "Manage your daily check-in / check-out operations and review historical logs.")}
        </Typography> */}
      </Box>

      <Grid container spacing={3}>
        {/* Left column: Daily Widget */}
        <Grid item xs={12} lg={4}>
          <Box sx={{ position: { lg: "sticky" }, top: "24px" }}>
            <TeacherCheckInCard />
          </Box>
        </Grid>

        {/* Right column: Monthly History */}
        <Grid item xs={12} lg={8}>
          <TeacherAttendanceCalendar />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TeacherAttendancePage;
